/**
 * `reference` had the same grey as `other`, which made an encyclopedia
 * indistinguishable at a glance from an unclassified source. That mattered
 * little while the analysis pipeline could not produce `reference` at all; now
 * that it can, a corrected label that nobody can see would not be a fix.
 *
 * Spec 230 — restyled onto `.hub-chip` + the closest-meaning tone. Kridt has
 * four tones (ok/info/warn/fail), fewer than the eight domain types, so
 * several share a tone; `reference` keeps a tone (`info`) distinct from
 * `other`'s plain neutral chip, preserving the distinction the comment above
 * exists for.
 */
const TYPE_TONE: Record<string, 'ok' | 'info' | 'warn' | 'fail' | undefined> = {
  you: 'ok',
  competitor: 'fail',
  institutional: 'info',
  editorial: 'info',
  corporate: undefined,
  reference: 'info',
  ugc: 'warn',
  other: undefined,
};

export function DomainTypeBadge({ type }: { type: string }) {
  const tone = type in TYPE_TONE ? TYPE_TONE[type] : undefined;
  return (
    // Spec 230: gate 200.C.1 used to find this badge as "the row's only
    // span.rounded-full". The .hub-chip restyle removed that Tailwind class,
    // so the badge is anchored by testid now — the same fix the brand picker
    // needed, and stronger than locating a component by an incidental
    // utility class it happens to carry.
    <span
      data-testid="domain-type-badge"
      className={`hub-chip${tone ? ` hub-chip--${tone}` : ''}`}
    >
      {type}
    </span>
  );
}
